//import 'bootstrap/dist/css/bootstrap.min.css'
import './App.css';
import MovieCard from './MovieCard';
import Home from './Home';
import Login from './Login';
import Register from './Register';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import NotFound from './NotFound';
import './movieStyle.css';
import Dashboard from './Dashboard';

function App() {

  return (
    <Router>
      <div className="App">
      <div className="movie-content">
        <Switch>
          <Route exact path="/">
            <Home/>
          </Route>

          <Route exact path="/register">
            <Register/>
          </Route>

          <Route exact path="/login">
            <Login/>
          </Route>

          <Route exact path="/movieCard">
            <MovieCard/>
          </Route>

          <Route exact path="/dashboard">
            <Dashboard/>
          </Route>
   
          <Route path="*">
            < NotFound/>
          </Route>
        </Switch>
      </div>
    </div>
    </Router>
  );
}

export default App;
